export const permissionsEnergyContractReadonly = [
  "energy-contracts-readonly",
  "energy-contracts-full",
  "everything-full",
  "everything-readonly",
];
